import { createFileRoute } from '@tanstack/react-router';

import { WinbackOfferDownloadAppsPage } from 'src/apps/checkout/app/pages/WinbackOffer.DownloadApps';

export const Route = createFileRoute(
  '/_auth/_only-header/store/methods-offer/download-apps'
)({
  component: () => <WinbackOfferDownloadAppsPage />,
});
